export class MemberAreas{
    constructor() {
        this.login = 'login';
        this.create = 'create'
        this.menu = 'menu';
        this.resetPassword = 'resetPassword';
    }
};
export default new MemberAreas();